import { apiClient } from '../core/client';

export const fetchOptions = async () => {
  const res = await apiClient(`${process.env.REACT_APP_API_URL}telemetry_dashboard_data/options/`);

  return res.json();
};
